angular.module('account').controller('EmailOptOutCtrl',
    ['$scope', 'toaster', 'aprgettext', 'TransitionManager', 'ContentAttributeService', 'Bridge', 'configuration', 'SessionService', 'AccountRepository', 'LocalStorageRepository', '$stateParams',
        function ($scope, toaster, gettext, TransitionManager, ContentAttributeService, Bridge, configuration, SessionService, AccountRepository, LocalStorageRepository, $stateParams) {
            'use strict';

            $scope.loading = false;
            $scope.processed = false;
            $scope.invalidAccessCode = false; // assume initially that all is good
            $scope.model = {  // setup and initialize dto
                AccessCode: $stateParams.accessCode,
                ClientId: LocalStorageRepository.getClientID(),
                EmailAddress: '',
                IsOptOutPatientMarketing: false,
                IsOptOutStatement: true,
            };

            $scope.onLoad = onLoad;

            if (!configuration.DEV_HOSTED) {
                ContentAttributeService.getClientConfig()
                    .then(function (data) {
                        if (data) {
                            var oldClientId = LocalStorageRepository.getClientID();

                            if (oldClientId !== data.clientId) {
                                LocalStorageRepository.clearAll();
                            }
                            
                            LocalStorageRepository.setClientURL(data.hostUrl);
                            LocalStorageRepository.setClientID(data.clientId);
                            $scope.model.ClientId = LocalStorageRepository.getClientID();

                            $scope.onLoad($scope.model.AccessCode, $scope.model.ClientId); 

                        } else {
                            $scope.errorMessage = gettext('Error loading page. Unknown Client Id');
                            Bridge.createModalAlert({
                                title: gettext('Loading Error'),
                                message: $scope.errorMessage,
                                buttons: [gettext('Okay')]
                            });
                        }
                    }).catch(function () {
                    $scope.errorMessage = gettext('Error loading page. Unknown Client Id');
                    Bridge.createModalAlert({
                        title: gettext('Loading Error'),
                        message: $scope.errorMessage,
                        buttons: [gettext('Okay')]
                    });
                });
            }

            $scope.back = back;

            $scope.submit = submit;

            function back() {
                SessionService.setDisplayDashboardToolbar(false);
                TransitionManager.transition({appRoute: 'login'});
            }

            function onLoad(accessCode, clientId) {
                
                $scope.loading = true;
                var params = {
                    accessCode: accessCode,
                    clientId: clientId,
                };
                
                AccountRepository.getOptOutOfEmaiDetails(params)
                    .then(function (data) {
                        $scope.model.EmailAddress = data.Result.EmailAddress;
                        $scope.invalidAccessCode = false;
                    })
                    .catch(function () {
                        toaster.pop('error', '', gettext('EmailOptOutInfo Load Failed. Please try again or contact your practice for further assistance.'));
                        $scope.invalidAccessCode = true;
                    })
                    .finally(function () {
                        $scope.loading = false;
                    });
            }

            function submit() {

                $scope.loading = true;

                AccountRepository.postOptOutEmail($scope.model)
                    .then(function () {
                        toaster.pop('success', '', gettext('OptOut has been changed successfully.'));
                        $scope.processed = true;
                    })
                    .catch(function () {
                        toaster.pop('error', '', gettext('OptOut Failed. Please try again or contact your practice for further assistance.'));
                    })
                    .finally(function () {
                        $scope.loading = false;
                    });
            }
        }]);